import axios from "axios";

export const getAllCategoriesAsync = async () => {
  const response = await axios.get("catalog-types");
  console.log(response.data, "from api cat");
  return response.data;
};
